
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/component-library/icons",
      function () {
        return require("private-next-pages/component-library/icons.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/component-library/icons"])
      });
    }
  